import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_role } from '../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_GRID2D__view } from '../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__viewport } from '../../_invocations/image/INVOCATION_IMAGE__viewport';
import { INVOCATION_VISION_CV2__control_line_guidance_canny_auto } from '../../_invocations/vision/line_guidance/canny/INVOCATION_VISION_CV2__control_line_guidance_canny_auto';
import { ENUM__graph_template_name } from '../sd_1/ENUM__graph_template_name';

export function GENERATION_TOOL__vision__canny_auto() {
  /*
   *
   */

  let out = new DTO__generation_tool();
  out.name = ENUM__graph_template_name.CREATE_LINES_CANNY_AUTO;

  const graph = DTO_GRAPH__instance.CREATE_NEW();
  out.graph = graph;

  /*
   * COLOR GRID2D VIEW
   */
  const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

  /*
   *
   */

  const node__crop_and_mask = INVOCATION_IMAGE__viewport.create_node_for(graph, ENUM__invocation_role.CORE__IMAGE_VIEWPORT);

  /*
   *
   */

  const node__line_guidance_canny_auto = INVOCATION_VISION_CV2__control_line_guidance_canny_auto.create_node_for(
    graph,
    ENUM__invocation_role.VISION__LINE_CANNY__AUTO,
  );
  graph.edge__try_add_for_fields(node__line_guidance_canny_auto.out, node__grid2d.image);
  graph.edge__try_add_for_fields(node__crop_and_mask.out__image_cropped, node__line_guidance_canny_auto.image);

  /*
   *
   */

  /*
   *
   */

  let fields__visible: FIELD__base[] = [node__crop_and_mask.image];
  out.view__add({ fields__visible, fields__stored: fields__visible });

  /*
   *
   */

  return out;
}
